import { getGraphqlClient } from "@lib/graphql-client"
import { extractErrorCode } from "@lib/parse-error"
import { useDispatch } from "@lib/store"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useCallback } from "react"

const { sdk } = getGraphqlClient()
export const useCancelEnhancementById = (id?: string) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const cancelEnhancementMutation = useMutation({
    mutationFn: async (enhancementId: string) => {
      return await sdk.CancelEnhancement({
        id: enhancementId,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tasks-list"] })
      queryClient.invalidateQueries({ queryKey: ["uploads"] })
      queryClient.invalidateQueries({ queryKey: ["upload"] })
    },
  })
  const cancelEnhancement = useCallback(async () => {
    if (!id) {
      return
    }
    const confirm = window.confirm(
      `Are you sure you want to cancel this enhancement? This action cannot be undone.`,
    )

    if (confirm) {
      try {
        await cancelEnhancementMutation.mutateAsync(id)
        dispatch({
          type: "add-toast",
          payload: {
            variant: "success",
            title: "Cancel enhancement successfully",
          },
        })
      } catch (e) {
        dispatch({
          type: "add-toast",
          payload: {
            variant: "error",
            title: extractErrorCode(e),
          },
        })
      }
    }
  }, [id])

  return {
    cancelEnhancement,
  }
}
